import { render, staticRenderFns } from "./RemuneracaoItensRightNavBar.vue?vue&type=template&id=160987c9"
import script from "./RemuneracaoItensRightNavBar.vue?vue&type=script&lang=ts"
export * from "./RemuneracaoItensRightNavBar.vue?vue&type=script&lang=ts"
import style0 from "./RemuneracaoItensRightNavBar.vue?vue&type=style&index=0&id=160987c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports